import {
  SET_USER,
  SET_ROOT,
  SET_HAS_LOGGED_OUT,
  SET_ROLE,
} from '@/store/modules/user/mutations';
import {
  DEFINE_USER, CLEAR_USER,
  DEFINE_ROOT, RECOVER_ROOT,
  DEFINE_HAS_LOGGED_OUT,
  DEFINE_SESSION_USER_ROLE,
} from '@/store/modules/user/actions';


export default {
  state: {
    user: null,
    root: null,
    role: null,
    hasLoggedOut: false,
  },
  getters: {
    user: state => state.user,
    root: state => state.root,
    hasLoggedOut: state => state.hasLoggedOut,
    role: state => state.role,
  },
  mutations: {
    [SET_USER](state, user) {
      state.user = user;
    },
    [SET_ROOT](state, root) {
      state.root = root;
      if (root === null || root === undefined) {
        localStorage.removeItem('root');
      } else {
        localStorage.root = JSON.stringify(root);
      }
    },
    [SET_HAS_LOGGED_OUT](state, hasLoggedOut) {
      state.hasLoggedOut = hasLoggedOut;
    },
    [SET_ROLE](state, role) {
      state.role = role;
    },
  },
  actions: {
    [DEFINE_USER](context, payload) {
      context.commit(SET_USER, payload.user);
    },
    [CLEAR_USER](context) {
      context.commit(SET_USER, null);
    },
    [DEFINE_ROOT](context, payload) {
      context.commit(SET_ROOT, payload.root);
    },
    [RECOVER_ROOT](context) {
      try {
        const root = JSON.parse(localStorage.root);
        context.dispatch(DEFINE_ROOT, { root });
      } catch (_) { /* Ignore if root is not localStorage. */ }
    },
    [DEFINE_HAS_LOGGED_OUT](context, payload) {
      context.commit(SET_HAS_LOGGED_OUT, payload.hasLoggedOut);
    },
    [DEFINE_SESSION_USER_ROLE](context, payload) {
      context.commit(SET_ROLE, payload.role);
    },
  },
};
